const PAYMENT_CONFIG_BASE_URL = '/payment/api/config'

export const paymentConfigUrls = {
  publicKey: '/payment/api/public-key',
  paymentMethods: companyId =>
    `${PAYMENT_CONFIG_BASE_URL}/payment-methods?companyId=${companyId}`,
  paymentMethodFields: paymentTypeId =>
    `${PAYMENT_CONFIG_BASE_URL}/payment-methods/${paymentTypeId}/fields`,
  paymentMethodConfig: (paymentTypeId, companyId) =>
    `${PAYMENT_CONFIG_BASE_URL}/payment-methods/${paymentTypeId}?companyId=${companyId}`,
  savePaymentMethodConfig: paymentTypeId =>
    `${PAYMENT_CONFIG_BASE_URL}/payment-methods/${paymentTypeId}`,
  updatePaymentMethodStatus: paymentTypeId =>
    `${PAYMENT_CONFIG_BASE_URL}/payment-methods/${paymentTypeId}/status`,
}
